// Global variables
const ds_schedule = $('.pbl-schedules');
let schedules, standings, t1_s1_sc1, t1_s1_sc2, tm1_st1_tb, 
    tm1_st2_sc1, tm1_st2_sc2, tm1_st2_tb, tm1_match, t2_s1_sc1, 
    t2_s1_sc2, tm2_st1_tb, tm2_st2_sc1, tm2_st2_sc2, tm2_st2_tb, 
    tm2_match, ds_schedule_col, schedules_count;

// Retrieve All Events for the AZPBL Schedule
function getAllEvents() {
  $.ajax({ 
      url: 'https://tnp.mysites.io/wp-json/pbl/v1/all-season-events',
      dataType: 'text'
  })
  .done((res) => {
      schedules = JSON.parse(res);
      schedules_count = schedules[0].length;
      init_schedule();
  })
  .fail((res) => {
      console.log('Failed to retrieve all season event data!');
  })
}

getAllEvents();

// Format the event date (to display on the left-side of the banner)
function formatScheduleDates(d) {
  let date = new Date(d);
      month = date.toLocaleDateString('default', {month: 'long'}),
      day = date.toLocaleDateString('default', {weekday: 'long'}),
      weekday = date.getDate();

  //Format the day & month: "tuesday"->"tue" || "April"->"Apr"
  if(month) {
    let parsed_month = month.split("");
    month = parsed_month.slice(0,3).toString().replaceAll(",", "");
  }

  return `${month} ${weekday}`;
}

// Determine if the event's title (Will be different if the last three events are upcoming)
function formatEventTitle(team1, team2, i, j) {
  if(((team1 === null || team1 === undefined || isNaN(team1) !== false ) && (team2 === null || team2 === undefined || isNaN(team1) !== false) && schedules[i][j]['event_title'] !== '')) {
    return `${schedules[i][j]['event_title']}`; // Event Title Property
  } 
  
  // Default title
  return `${team1} <br class="sm-only"> vs ${team2} <br class="sm-only">`;
}

// Populates the dynamic schedules section of the AZPBL Page according to the data we have in the PWA.
function dynamicSchedules() {
  for(let i = 0; i < schedules.length; i++) {
    for(let j = 0; j < schedules_count; j++) {
      if(i === 0){
        schedule_init(i, j); 
      }

      // Will allow users to select from either the season 1 or season 2 schedule.
      $('#schedules_selector').change(()=>{
         if($(`#schedules_selector option:selected`).val() === `season--${(schedules.length) - i}`){
           schedule_table(i, j); 
         }
      }); 
    }
  }
}

// Initialize Schedule Table on latest seasons
function schedule_init(i, j) {
  // Create the schedule base
  if(j == 0) {
    ds_schedule.append(
      `<div class="row">`+
        `<div class="col-4 md-col-12 md-text-center">`+
          `<h2 class="pbl-schedules__title"> Season Schedule </h2>`+
          `<nav class="pbl-schedules__row--selector">`+
            `<div class="custom-select blue">`+
              `<label class="sr-only">Choose your TNP season:</label>`+
              `<span class="custom-arrow"></span>`+
              `<select id="schedules_selector">`+
                `<option class="ssb_1" value="season--1">Season 1</option>`+
                `<option class="ssb_2" value="season--2" selected="true">Season 2</option>`+
              `</select>`+
            `</div>`+
          `</nav>`+
        `</div>`+
        `<div class="col-7 md-col-10 sm-col-12 pbl-schedules__col">`+
        `</div>`+
      `</div>`
    );
  }
  
  schedule_table(i, j);
}

// Create the schedule table based on the chosen season. 
function schedule_table(i, j) {
  if($('.pbl-schedules__col .pbl-schedules__row').length === (schedules_count) && (j === 0)) {
     $('.pbl-schedules__row').remove();
  }
    //Create each column according to the the number of events found in the AZPBL Word Press Database.
    ds_schedule_col = $(`.pbl-schedules__col`);
  
    ds_schedule_col.append(
      `<div class="row row--align-items-center pbl-schedules__row schedule_col--${j+1}">`+
          `<div class="col-1 md-col-2 sm-col-2 pbl-schedules__col-left">`+
            `<h4 class="pbl-schedules__date">${formatScheduleDates(schedules[i][j]['end_date'])}</h4>`+
          `</div>`+
          `<div class="col-10 md-col-10 sm-col-10 pbl-schedules__col-right">`+
            `<h3 class="pbl-schedules__teams">${formatEventTitle(schedules[i][j]['teams'][0]['team_1']['team_name'], schedules[i][j]['teams'][1]['team_2']['team_name'], i, j)}</h3>`+
              `<div class="pbl-schedules__col-right__wrap">`+
              `</div>`+
          `</div>`+
      `</div>`
    );

    /******* Schedule Row Buttons *******/
    let ds_schedule_btns = $(`.schedule_col--${j+1} .pbl-schedules__col-right__wrap`),
        curr_date = new Date(),
        schedules_date = new Date(schedules[i][j]['end_date']);

    // Determine if the event is current or passed. If so, remove the buy button.
    if(curr_date < schedules_date && schedules[i][j]['buy_button_link'] !== "" && schedules[i][j]['buy_button_link'] !== null) {
      // Buy Button
      ds_schedule_btns.append(
        `<a href="${schedules[i][j]['buy_button_link']}" class="pbl-schedules__buy-button button" target="_blank" rel="noopener noreferrer">Buy Tickets</a>`
      );
    } 
    // Determine if there is a youtube link attached to the event. If not, remove the youtube button.
    if(curr_date > schedules_date) {
      // Youtube Link
      if(schedules[i][j]['youtube_link'] !== "" && schedules[i][j]['youtube_link'] !== null) {
        ds_schedule_btns.append(
          `<a href="${schedules[i][j]['youtube_link']}" class="pbl-schedules__watch-button button" target="_blank" rel="noopener noreferrer">Watch Event</a>`
        );
      }

      // Determine if there are scores attached to the event. If so, display the event button.
      if(schedules[i][j]['season'] !== 'season-1') {
        /*** (Used for Season 2 Scoring) ***/ 
        if(((isNaN(schedules[i][j]['teams'][0]['team_1']['team_scores']['set_1']['game_1_score']) !== true) && schedules[i][j]['teams'][0]['team_1']['team_scores']['set_1']['game_1_score'] !== '')) {
          ds_schedule_btns.append(
            `<a class="pbl-schedules__results-button button" id="results-modal-${j+1}" data-remodal-target="dynamic-modal">View Results</a>`
          ); 
        }  
      } else {
        /*** (Used for Season 1 Scoring) ***/
        if((schedules[i][j]['teams'][0]['team_1']['team_scores']['total'] !== '') && (schedules[i][j]['teams'][1]['team_2']['team_scores']['total'] !== '')) {
          ds_schedule_btns.append(
            `<a class="pbl-schedules__results-button button" id="results-modal-${j+1}" data-remodal-target="dynamic-modal">View Results</a>` 
          )
        }
      }
      
      // Determine if there is a link to a previous game's photos. If not, don't display photo button.
      if(schedules[i][j]['photos_link'] !== "" && schedules[i][j]['photos_link'] !== null) {
        ds_schedule_btns.append(
         `<a href="${schedules[i][j]['photos_link']}" class="pbl-schedules__photos-button button" target="_blank" rel="noopener noreferrer">View Photos</a>`
        ); 
      }
    }

    // Dynamically create the modal interface and attach an ID to each modal results button, along with an event handler to call them.
    $(`#results-modal-${j+1}`).click(()=>{
      modalFunctionality(j);

        // Season 2 Interface and Score Calculator
        if(i === 0) {
          seasonTwoInterface(i, j);
          seasonTwoWinningTeam(); 
        } else if(i === 1) {
          // Season 1 Interface and Score Calculator
          seasonOneInterface(i, j);
          seasonOneWinningTeam(i, j);
        }
    });
}

// This method determines if a match breaker or tie breaker is NaN or an integer.
function determineTieBreaker(n) { 
  // If the tie-breaker is a 0, then the value will be crossed out or voided.
  if(typeof(n) !== 'number' || isNaN(n) === true) {
    return '-'; 
  } else {
    return n; 
  }
}

// The modal's event handlers for user interaction.
function modalFunctionality(i) {
  // Adds an ID class to the modal.
  $(`#results-modal-${i+1}`).on('click', function() {
    $('.modal-match-results').addClass(`modal-match-results--${i+1}`);
  });

  // Removes all content from the Remodal
  $('.remodal-close').click(() => {
    $('.modal-match-results').removeClass(`modal-match-results--${i+1}`);
    $('.modal-match-results #dynamic-modal-interface').text('');
  });
}

// The modal's interface that will be injected with each event's data for season 2.
function seasonTwoInterface(i, j) {
  // Apply team score values to global variables
  t1_s1_sc1 = parseInt(schedules[i][j]['teams'][0]['team_1']['team_scores']['set_1']['game_1_score']);
  t1_s1_sc2 = parseInt(schedules[i][j]['teams'][0]['team_1']['team_scores']['set_1']['game_2_score']);
  t1_s1_tb = parseInt(schedules[i][j]['teams'][0]['team_1']['team_scores']['set_1']['tie_breaker_score']);
  t1_s2_sc1 = parseInt(schedules[i][j]['teams'][0]['team_1']['team_scores']['set_2']['game_1_score']);
  t1_s2_sc2 = parseInt(schedules[i][j]['teams'][0]['team_1']['team_scores']['set_2']['game_2_score']);
  t1_s2_tb = parseInt(schedules[i][j]['teams'][0]['team_1']['team_scores']['set_2']['tie_breaker_score']);
  t1_match = parseInt(schedules[i][j]['teams'][0]['team_1']['team_scores']['match']['match_break_score']);
  
  t2_s1_sc1 = parseInt(schedules[i][j]['teams'][1]['team_2']['team_scores']['set_1']['game_1_score']);
  t2_s1_sc2 = parseInt(schedules[i][j]['teams'][1]['team_2']['team_scores']['set_1']['game_2_score']);
  t2_s1_tb = parseInt(schedules[i][j]['teams'][1]['team_2']['team_scores']['set_1']['tie_breaker_score']);
  t2_s2_sc1 = parseInt(schedules[i][j]['teams'][1]['team_2']['team_scores']['set_2']['game_1_score']);
  t2_s2_sc2 = parseInt(schedules[i][j]['teams'][1]['team_2']['team_scores']['set_2']['game_2_score']);
  t2_s2_tb = parseInt(schedules[i][j]['teams'][1]['team_2']['team_scores']['set_2']['tie_breaker_score']);
  t2_match = parseInt(schedules[i][j]['teams'][1]['team_2']['team_scores']['match']['match_break_score']);
  
  $('.modal-match-results #dynamic-modal-interface').append(
    `<div class="pbl-score">`+
      `<div class="row pbl-score__title">`+
        `<div class="col col-centered pbl-score__title--col">`+ 
          `<h2>${schedules[i][j]['teams'][0]['team_1']['team_name']}<br class="lg-hide"> <el class="pbl-score__title--vs">vs</el> <br class="lg-hide">${schedules[i][j]['teams'][1]['team_2']['team_name']}</h2>`+
        `</div>`+
      `</div>`+ 
      `<div class="pbl-score__board-wrapper">`+
        `<div class="row pbl-score__header lg-only">`+
          `<div class="col-5 md-col-2 lg-only fill_space"></div>`+
          `<div class="col-3 md-col-4">`+
            `<div class="score_heading">`+
              `<p> Set 1 </p>`+
            `</div>`+
          `</div>`+
          `<div class="col-3 md-col-4">`+
            `<div class="score_heading">`+
              `<p> Set 2 </p>`+
            `</div>`+
          `</div>`+
          `<div class="col-1 md-col-2">`+
            `<div class="score_heading">`+
              `<p> Match Brk </p>`+
            `</div>`+
          `</div>`+
        `</div>`+
        `<div class="row pbl-score__team--1">`+
            `<div class="col-4 md-col-2 col-no-pad stretch">`+
              `<div class="team-1__info">`+
                `<img class="team-1__icon" src="${schedules[i][j]['teams'][0]['team_1']['team_icon']}" loading="lazy"/>`+
                `<p class="team-1__name md-hide sm-hide">${schedules[i][j]['teams'][0]['team_1']['team_name']}</p>`+
              `</div>`+
            `</div>`+
            `<div class="col-3 md-col-4 col-no-pad stretch">`+
              `<div class="row team-1__scoreboard_row">`+
                `<div class="col-4 tile_wrap"><p class="lg-hide tile_wrap__text">Set 1</p><div class="team-1__scoreboard_row--s1_score1 top_lt_score"><p>${t1_s1_sc1}</p></div></div>`+
                `<div class="col-4 tile_wrap"><div class="team-1__scoreboard_row--s1_score2 mid_score"><p>${t1_s1_sc2}</p></div></div>`+
                `<div class="col-4 tile_wrap"><div class="team-1__scoreboard_row--s1_tie_breaker top_rt_score"><p>${determineTieBreaker(t1_s1_tb)}</p></div></div>`+
              `</div>`+
            `</div>`+
            `<div class="col-3 md-col-4 col-no-pad stretch">`+
              `<div class="row team-1__scoreboard_row">`+
                `<div class="col-4 tile_wrap"><p class="lg-hide tile_wrap__text">Set 2</p><div class="team-1__scoreboard_row--s2_score1 top_lt_score"><p>${t1_s2_sc1}</p></div></div>`+
                `<div class="col-4 tile_wrap"><div class="team-1__scoreboard_row--s2_score2 mid_score"><p>${t1_s2_sc2}</p></div></div>`+
                `<div class="col-4 tile_wrap"><div class="team-1__scoreboard_row--s2_tie_breaker top_rt_score"><p>${determineTieBreaker(t1_s2_tb)}</p></div></div>`+
              `</div>`+
            `</div>`+
            `<div class="col-1 md-col-2 col-no-pad stretch">`+
              `<div class="row team-1__scoreboard_row">`+
                `<div class="col-12 tile_wrap"><p class="lg-hide tile_wrap__text">Match<br>Brk</p><div class="team-1__scoreboard_row--match_score mb_top"><p>${determineTieBreaker(t1_match)}</p></div></div>`+
              `</div>`+
            `</div>`+
          `</div>`+
        `<div class="row pbl-score__team--2">`+
            `<div class="col-4 md-col-2 col-no-pad stretch">`+
              `<div class="team-2__info">`+
                `<img class="team-2__icon" src="${schedules[i][j]['teams'][1]['team_2']['team_icon']}" loading="lazy" />`+
                `<p class="team-2__name md-hide sm-hide">${schedules[i][j]['teams'][1]['team_2']['team_name']}</p>`+
              `</div>`+
            `</div>`+
            `<div class="col-3 md-col-4 col-no-pad stretch">`+
              `<div class="row team-2__scoreboard_row">`+
                `<div class="col-4 tile_wrap"><div class="team-2__scoreboard_row--s1_score1 btm_lt_score"><p>${t2_s1_sc1}</p></div></div>`+
                `<div class="col-4 tile_wrap"><div class="team-2__scoreboard_row--s1_score2 mid_score"><p>${t2_s1_sc2}</p></div></div>`+
                `<div class="col-4 tile_wrap"><div class="team-2__scoreboard_row--s1_tie_breaker btm_rt_score"><p>${determineTieBreaker(t2_s1_tb)}</p></div></div>`+
              `</div>`+
            `</div>`+
            `<div class="col-3 md-col-4 col-no-pad stretch">`+
              `<div class="row team-2__scoreboard_row">`+
                `<div class="col-4 tile_wrap"><div class="team-2__scoreboard_row--s2_score1 btm_lt_score"><p>${t2_s2_sc1}</p></div></div>`+
                `<div class="col-4 tile_wrap"><div class="team-2__scoreboard_row--s2_score2 mid_score"><p>${t2_s2_sc2}</p></div></div>`+
                `<div class="col-4 tile_wrap"><div class="team-2__scoreboard_row--s2_tie_breaker btm_rt_score"><p>${determineTieBreaker(t2_s2_tb)}</p></div></div>`+
              `</div>`+
            `</div>`+
            `<div class="col-1 md-col-2 col-no-pad stretch">`+
              `<div class="row team-2__scoreboard_row">`+
                `<div class="col-12 tile_wrap"><div class="team-2__scoreboard_row--match_score mb_btm"><p>${determineTieBreaker(t2_match)}</p></div></div>`+
              `</div>`+
            `</div>`+
          `</div>`+
      `</div>`+
  `</div>`
  );
}

// Determing the winning team in a game for season 2.
function seasonTwoWinningTeam() {
  if(schedules) {
    let tm1_s1_wins = 0, tm1_s2_wins = 0, tm1_match_wins = 0, tm2_s1_wins = 0,
        tm2_s2_wins = 0, tm2_match_wins = 0, tm1_set_total = 0, tm2_set_total = 0,
        tm1_total = 0, tm2_total = 0;

    // Compare teams wins for each round in a set
    /*----- Team One -----*/
    if(t1_s1_sc1 > t2_s1_sc1) { tm1_s1_wins++; }
    if(t1_s1_sc2 > t2_s1_sc2) { tm1_s1_wins++; }
    if(t1_s1_tb > t2_s1_tb) { tm1_s1_wins++; }
    if(t1_s2_sc1 > t2_s2_sc1) { tm1_s2_wins++; }
    if(t1_s2_sc2 > t2_s2_sc2) { tm1_s2_wins++; }
    if(t1_s2_tb > t2_s2_tb) { tm1_s2_wins++; }

    /*----- Team Two -----*/
    if(t1_s1_sc1 < t2_s1_sc1) { tm2_s1_wins++; }
    if(t1_s1_sc2 < t2_s1_sc2) { tm2_s1_wins++; }
    if(t1_s1_tb < t2_s1_tb) { tm2_s1_wins++; }
    if(t1_s2_sc1 < t2_s2_sc1) { tm2_s2_wins++; }
    if(t1_s2_sc2 < t2_s2_sc2) { tm2_s2_wins++; }
    if(t1_s2_tb < t2_s2_tb) { tm2_s2_wins++; }

    // SET 1: If team one wins a round, then mark their set blue. Else mark team two's set.
    if(tm1_s1_wins > tm2_s1_wins) {
      $('.team-1__scoreboard_row--s1_score1').addClass('winning_score');
      $('.team-1__scoreboard_row--s1_score2').addClass('winning_score');
      $('.team-1__scoreboard_row--s1_tie_breaker').addClass('winning_score');
      tm1_set_total++;
    } else if(tm1_s1_wins < tm2_s1_wins) {
      $('.team-2__scoreboard_row--s1_score1').addClass('winning_score');
      $('.team-2__scoreboard_row--s1_score2').addClass('winning_score');
      $('.team-2__scoreboard_row--s1_tie_breaker').addClass('winning_score');
      tm2_set_total++;
    }

    // SET 2: If team one wins a round, then mark their set blue. Else mark team two's set.
    if(tm1_s2_wins > tm2_s2_wins) {
      $('.team-1__scoreboard_row--s2_score1').addClass('winning_score');
      $('.team-1__scoreboard_row--s2_score2').addClass('winning_score');
      $('.team-1__scoreboard_row--s2_tie_breaker').addClass('winning_score');
      tm1_set_total++;
    } else if(tm1_s2_wins < tm2_s2_wins) {
      $('.team-2__scoreboard_row--s2_score1').addClass('winning_score');
      $('.team-2__scoreboard_row--s2_score2').addClass('winning_score');
      $('.team-2__scoreboard_row--s2_tie_breaker').addClass('winning_score');
      tm2_set_total++;
    }

    // MATCH: Determine if there should be a match break between the two teams.
    if(tm1_set_total === tm2_set_total) {
      // Check if the match values contain a NaN.
      if(isNaN(t1_match)) { t1_match = 0; }
      if(isNaN(t2_match)) { t2_match = 0; }
      
      if(t1_match > t2_match) {
        tm1_match_wins++;
      } else if(t1_match < t2_match) {
        tm2_match_wins++;
      }

      // Compare the team match points, to determine the winnder of the match breaker.
      if((tm1_match_wins > tm2_match_wins)) {
        $('.team-1__scoreboard_row--match_score').addClass('winning_score');
      } else if((tm1_match_wins < tm2_match_wins)) {
        $('.team-2__scoreboard_row--match_score').addClass('winning_score');
      } 
    }

    // Gather the total matches won in a game
    tm1_total = tm1_set_total + tm1_match_wins;
    tm2_total = tm2_set_total + tm2_match_wins;

    // Determine the winner of the game
    if(tm1_total > tm2_total) {
      $('.team-1__info').addClass('winning_team');
    } else if(tm1_total < tm2_total) {
      $('.team-2__info').addClass('winning_team');
    }
  }
}

// The modal's interface that will be injected with each event's data for season 1.
function seasonOneInterface(i, j) {
  $('.modal-match-results #dynamic-modal-interface').append(
     `<div class="row table-date">`+
      `<div class="col-12">`+
        `<h2 class="table-date__content text-center">
          Week ${j+1} - ${formatScheduleDates(schedules[i][j]['end_date'])}
         </h2>`+
      `</div>`+
      `<div class="col-12 lg-hide team__name">`+
        `<p>
        ${schedules[i][j]['teams'][0]['team_1']['team_name']}<br>Vs<br> ${schedules[i][j]['teams'][1]['team_2']['team_name']}
        </p>`+
      `</div>`+
    `</div>`+
    `<div class="modal-match-results__wrap-table">`+
      `<div class="row table-header">`+
        `<div class="col-7 empty-space">`+
      `</div>`+
      `<div class="col-1 table-header__quarter first">`+
         `<p>Q1<br class="lg-only"><span class="lg-hide"> </span>Mixed</p>`+
      `</div>`+
      `<div class="col-1 table-header__quarter">`+
         `<p>Q2<br class="lg-only"><span class="lg-hide"> </span>Mixed</p>`+
      `</div>`+
      `<div class="col-1 table-header__quarter">`+
          `<p>Q3<br class="lg-only"><span class="lg-hide"> </span>Womens</p>`+
      `</div>`+
      `<div class="col-1 table-header__quarter">`+
          `<p>Q4<br class="lg-only"><span class="lg-hide"> </span>Mens</p>`+
      `</div>`+
      `<div class="col-1 table-header__quarter">`+
          `<p>Final<br class="lg-only"><span class="lg-hide"> </span>Score</p>`+
      `</div>`+
    `</div>`+
    `<div class="row first-team">`+
      `<div class="col-7 team__name">`+
        `<img class="team__img" src="${schedules[i][j]['teams'][0]['team_1']['team_icon']}">`+
          `<p class="text-left sm-hide lg-only">${schedules[i][j]['teams'][0]['team_1']['team_name']}</p>`+
      `</div>`+
      `<div class="col-1 team__score first">`+
          `<p>${schedules[i][j]['teams'][0]['team_1']['team_scores']['quarter_1']}</p>`+
      `</div>`+
      `<div class="col-1 team__score">`+
          `<p>${schedules[i][j]['teams'][0]['team_1']['team_scores']['quarter_2']}</p>`+
      `</div>`+
      `<div class="col-1 team__score">`+
          `<p>${schedules[i][j]['teams'][0]['team_1']['team_scores']['quarter_3']}</p>`+
      `</div>`+
      `<div class="col-1 team__score">`+
          `<p>${schedules[i][j]['teams'][0]['team_1']['team_scores']['quarter_4']}</p>`+
      `</div>`+
      `<div class="col-1 team__score">`+
          `<p>${schedules[i][j]['teams'][0]['team_1']['team_scores']['total']}</p>`+
      `</div>`+
    `</div>`+
    `<div class="row second-team">`+
      `<div class="col-7 team__name">`+
        `<img class="team__img" src="${schedules[i][j]['teams'][1]['team_2']['team_icon']}">`+
          `<p class="text-left sm-hide lg-only">${schedules[i][j]['teams'][1]['team_2']['team_name']}</p>`+
         `</div>`+
        `<div class="col-1 team__score first">`+
          `<p>${schedules[i][j]['teams'][1]['team_2']['team_scores']['quarter_1']}</p>`+
        `</div>`+
        `<div class="col-1 team__score">`+
          `<p>${schedules[i][j]['teams'][1]['team_2']['team_scores']['quarter_2']}</p>`+
        `</div>`+
        `<div class="col-1 team__score">`+
          `<p>${schedules[i][j]['teams'][1]['team_2']['team_scores']['quarter_3']}</p>`+
        `</div>`+
        `<div class="col-1 team__score">`+
          `<p>${schedules[i][j]['teams'][1]['team_2']['team_scores']['quarter_4']}</p>`+
        `</div>`+
        `<div class="col-1 team__score">`+
          `<p>${schedules[i][j]['teams'][1]['team_2']['team_scores']['total']}</p>`+
        `</div>`+
      `</div>`+
    `</div>`
  );
}

// Determing the winning team with the most points for season 1.
function seasonOneWinningTeam(i, j) {
  let teamOne_info = $('.modal-match-results__wrap-table .first-team'),
      teamTwo_info = $('.modal-match-results__wrap-table .second-team');
  
  // If team one has more points, then declare them the winning team. Otherwise make team two the winning team.
  if(schedules[i][j]['teams'][0]['team_1']['team_scores']['total'] > schedules[i][j]['teams'][1]['team_2']['team_scores']['total']) {
    teamOne_info.addClass('winning-team');
  } else if(schedules[i][j]['teams'][0]['team_1']['team_scores']['total'] < schedules[i][j]['teams'][1]['team_2']['team_scores']['total']) {
    teamTwo_info.addClass('winning-team');
  } else {
    teamOne_info.addClass('winning-team');
    teamTwo_info.addClass('winning-team');
  }
}

// Initialize the dynamic schedules.
function init_schedule() {
  dynamicSchedules();
}
